// deps
import React from "react";

// internal-deps
import { DELIVERY_SPEED } from "@swiggy-private/cart-types";
import { isEmpty } from "@swiggy-private/js-utils";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { useTheme } from "@swiggy-private/dls-web-theme/dist/components/ThemeProvider/use-theme";

// styles
import { ExpressIconWrapper } from "./styles";
import { getDlsColorForExpressIcon } from "./helpers";

export function ExpressIcon({
    type,
    selected,
    disabled,
    highlightColor,
}: {
    type?: string;
    selected?: boolean;
    disabled?: boolean;
    highlightColor?: string;
}) {
    const theme = useTheme();

    if (type !== DELIVERY_SPEED.EXPRESS) {
        return null;
    }

    const dlsColor = getDlsColorForExpressIcon({ selected, disabled, highlightColor });
    const color = theme.colors[theme.colorMode][dlsColor];

    // TODO: To be moved to DLS icon
    return (
        <ExpressIconWrapper>
            <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.236328 8.50879L4.9636 8.50879" stroke={color} />
                <path d="M2.12695 4.72754L5.90877 4.72754" stroke={color} />
                <path
                    d="M6.9284 6.08255L8.6987 3.50757C9.64575 2.13004 10.1193 1.44127 10.471 1.58325C10.8226 1.72523 10.6852 2.5497 10.4104 4.19863L10.2381 5.23237C10.204 5.43679 10.187 5.53899 10.2436 5.60586C10.3003 5.67273 10.4039 5.67273 10.6111 5.67273H11.2037C11.9932 5.67273 12.3879 5.67273 12.5208 5.92538C12.6537 6.17803 12.4301 6.50329 11.9828 7.15381L10.2125 9.72879C9.26547 11.1063 8.79194 11.7951 8.44027 11.6531C8.0886 11.5111 8.22601 10.6867 8.50084 9.03773L8.67313 8.00399C8.7072 7.79958 8.72423 7.69737 8.66759 7.6305C8.61094 7.56364 8.50732 7.56364 8.30009 7.56364H7.70749C6.91807 7.56364 6.52335 7.56364 6.39045 7.31099C6.25755 7.05834 6.48117 6.73308 6.9284 6.08255Z"
                    fill={color}
                />
            </svg>
        </ExpressIconWrapper>
    );
}

export function BannerIcon({ iconId }: { iconId?: string }) {
    if (isEmpty(iconId)) {
        return null;
    }

    return <Image cloudinaryId={iconId} width="16px" height="16px" />;
}
